import { useState, useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';
import { removeMainCat } from '../helpers/helpers.js';

const JobApplyForm = ({ jobDetail, anchorID }) => {
    const [isResumeActive, setIsResumeActive] = useState(false);
    const containerRef = useRef(null);

    const cnfg_debug = 'false',
        catId = jobDetail['job_category_id'][0],
        jobPostalRaw = jobDetail['job_postal']?.[0] ?? '',
        jobPostal = jobPostalRaw && jobPostalRaw.toLowerCase() !== 'none' ? jobPostalRaw.trim() : '0',
        jobId = jobDetail['job_order_id'][0],
        jobIdFull = jobId + '-' + jobPostal,
        jobcatdescription = removeMainCat(jobDetail['job_category'][0]),
        uuid = typeof document.onrecruit_uuid !== 'undefined' ? document.onrecruit_uuid : '',
        cnfg_form_code = 'RPH-JRS-3.0',
        cnfg_form_type_code = 'JRS',
        cnfg_bh_brands = 'RPh on the Go',
        //cnfg_discipline_hardcoded = 'pharmacy',
        cnfg_bh_discipine = 'pharmacy',
        specialtyOptions = [
          "Clinical Pharmacist",
          "Director of Pharmacy",
          "Pharmacist in Charge",
          "Pharmacy Clerk",
          "Pharmacy Manager",
          "Pharmacy Technician",
          "Staff Pharmacist",
        ],
        cnfg_email_subject_internal = 'Job Response from RPh on the Go Website',
        cnfg_sendfrom_internal = 'info@rphonthego.com',
        cnfg_thankyou_email_subject_external = 'Thank You for Your Recent Application on rphonthego.com',
        cnfg_template_external = 'RPH-Apply-Thank-You',
        cnfg_thankyou_url = `/pharmacy-jobs/thank-you/?jobid=${jobIdFull}&ty_cat=${catId}`;

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        zip: '',
        specialty: '', // New state variable for the position dropdown
        military_status: 'None',
        uploaded_resume: null,
        get_updates: true,
        agreement: false,
        uuid: uuid,
    });
 // 1. Use the useState hook to manage the visibility of the "more policy" text
    const [showMore, setShowMore] = useState(false);

    // 2. Create a handler function to toggle the state
    const handleToggleClick = (e) => {
        e.preventDefault(); // Prevents the page from reloading or jumping
        setShowMore(!showMore); // Toggles the state between true and false
    };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleFileChange = (e) => {
        if (e.target?.files?.[0]) {
            setFormData((prevData) => ({
                ...prevData,
                uploaded_resume: e.target.files[0],
            }));
        }
    };

    const handleFileChangeClick = () => {
        setIsResumeActive((prevState) => !prevState);
    };

    const handleMouseUp = (e) => {
        if (containerRef.current && !containerRef.current.contains(e.target)) {
            setIsResumeActive(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Submit form logic
        //console.log('Form submitted:', formData);
    };

    const loadScript = (src, onLoad) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = onLoad;
        document.body.appendChild(script);
    };

    // adds bhresume script, removes on unmount
    useEffect(() => {
        const bhresumeUrl = '/wp-content/themes/rph/modules/bh-apply/js/bhresume-min.js?ver=20250303';
        const formvalidateUrl = '/wp-content/themes/rph/modules/bh-apply/js/bh.formvalidate-min.js?ver=20251202.2';

        const handleBhresumeLoad = () => {
            //console.log('bhresume-min.js loaded successfully');
        };

        const handleFormValidateLoad = () => {
            //console.log('bh.formvalidate.js loaded successfully');
            // Initialize or call any function from the formvalidate script here
            if (window.validateForm) {
                window.validateForm();
            }
        };

        // Check if bhresume script is already loaded before appending it
        const existingBhresumeScript = document.querySelector(`script[src="${bhresumeUrl}"]`);
        if (!existingBhresumeScript) {
            loadScript(bhresumeUrl, handleBhresumeLoad);
        } else {
            handleBhresumeLoad(); // If already loaded, just call the function
        }

        // Check if formvalidate script is already loaded before appending it
        const existingFormValidateScript = document.querySelector(`script[src="${formvalidateUrl}"]`);
        if (!existingFormValidateScript) {
            loadScript(formvalidateUrl, handleFormValidateLoad);
        } else {
            handleFormValidateLoad(); // If already loaded, just call the function
        }

        // Cleanup function to remove the scripts when the component unmounts
        return () => {
            const bhresumeScript = document.querySelector(`script[src="${bhresumeUrl}"]`);
            if (bhresumeScript) {
                bhresumeScript.remove();
            }

            const formValidateScript = document.querySelector(`script[src="${formvalidateUrl}"]`);
            if (formValidateScript) {
                formValidateScript.remove();
            }
        };
    }, []);

    /**
     * // if we want the bhresume file to only load once, we need to import some of the functions for resume upload here
     
     useEffect(() => {
         const scriptId = 'bhresume';
         const scriptSrc = '/wp-content/themes/vocovision/modules/bh-apply/js/bhresume-min.js';

         // Check if the script already exists
         if (!document.getElementById(scriptId)) {
             const script = document.createElement('script');
             script.id = scriptId;
             script.src = scriptSrc;
             script.async = true;
             document.body.appendChild(script);

             // Optional: handle script load event
             script.onload = () => {
                 console.log('Script loaded successfully');
             };

             // Optional: handle script error event
             script.onerror = () => {
                 console.error('Script failed to load');
             };
         }
     }, []); // Empty dependency array ensures this runs only once
     **/

    useEffect(() => {
        document.addEventListener('mouseup', handleMouseUp);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
      <section id={anchorID} className="sec-job-apply bg-white form-bg-dark">
        <div className="include-wrap apply-form-container">
          <div
            className="rphform_wrapper bhform_wrapper bh_active_apply_wrapper"
            id="gform_wrapper_75"
          >
            <p className="gform_required_legend">
              <span className="gfield_required">*</span> Indicates a required
              field
            </p>
            <form
              method="post"
              id="bhapply"
              encType="multipart/form-data"
              noValidate
            >
              <input
                name="uuid"
                id="uuid"
                type="hidden"
                value={formData.uuid}
              />
              {/* Other hidden inputs */}
              <input name="cnfg_debug" type="hidden" value={cnfg_debug} />
              <input name="cnfg_form_url" type="hidden" value="" />
              <input
                name="cnfg_form_code"
                type="hidden"
                value={cnfg_form_code}
              />
              <input
                name="cnfg_form_type_code"
                type="hidden"
                value={cnfg_form_type_code}
              />
              <input
                name="cnfg_bh_brands"
                id="cnfg_bh_brands"
                type="hidden"
                value={cnfg_bh_brands}
              />
              <input name="cnfg_discipline_type" type="hidden" value="hidden" />
              <input
                name="cnfg_bh_discipine"
                type="hidden"
                value={cnfg_bh_discipine}
              />
              <input name="cnfg_bh_jobcatid" type="hidden" value={catId} />
              <input
                name="jobcatdescription"
                type="hidden"
                value={jobcatdescription}
              />
              <input name="job_order_id" type="hidden" value={jobIdFull} />
              <input
                name="cnfg_sendto_internal"
                id="cnfg_sendto_internal"
                type="hidden"
                value=""
              />
              <input name="cnfg_sendto_internal_cc" type="hidden" value="" />
              <input
                name="cnfg_sendfrom_internal"
                type="hidden"
                value={cnfg_sendfrom_internal}
              />
              <input
                name="cnfg_email_subject_internal"
                type="hidden"
                value={cnfg_email_subject_internal}
              />
              <input
                name="cnfg_sendfrom_external"
                type="hidden"
                value={cnfg_sendfrom_internal}
              />
              <input
                name="cnfg_thankyou_email_subject_external"
                type="hidden"
                value={cnfg_thankyou_email_subject_external}
              />
              <input
                name="cnfg_template_external"
                type="hidden"
                value={cnfg_template_external}
              />
              <input name="cnfg_thankyou_type" type="hidden" value="url" />
              <input
                name="cnfg_thankyou_url"
                type="hidden"
                value={cnfg_thankyou_url}
              />
              <input
                name="cnfg_thankyou_div_selector"
                type="hidden"
                value=".bhapply_thankyou"
              />

              <div className="bhform_body">
                <ul className="gform_fields top_label form_sublabel_below description_below">
                  <li>
                    <h3 className="h3">1. Personal Information</h3>
                  </li>
                  <li className="gfield gfield_contains_required field_sublabel_below field_description_below">
                    <label className="gfield_label" htmlFor="first_name">
                      First Name
                      <span className="gfield_required asterisk">*</span>
                    </label>
                    <div className="ginput_container ginput_container_text">
                      <input
                        name="first_name"
                        id="first_name"
                        type="text"
                        value={formData.first_name}
                        onChange={handleChange}
                        className="large format-alpha-only-extended"
                        aria-required="true"
                        required
                        pattern="^[\-\p{L}\u00c0-\u024f'. ]+$"
                        spellCheck="false"
                        data-error-text="Please enter a first name."
                        aria-invalid="false"
                      />
                    </div>
                  </li>
                  <li className="gfield gfield_contains_required field_sublabel_below field_description_below">
                    <label className="gfield_label" htmlFor="last_name">
                      Last Name
                      <span className="gfield_required asterisk">*</span>
                    </label>
                    <div className="ginput_container ginput_container_text">
                      <input
                        name="last_name"
                        id="last_name"
                        type="text"
                        value={formData.last_name}
                        onChange={handleChange}
                        className="large"
                        aria-required="true"
                        required
                        data-error-text="Please enter a last name."
                        aria-invalid="false"
                      />
                    </div>
                  </li>
                  <li className="gfield gfield_contains_required field_sublabel_below field_description_below">
                    <label className="gfield_label" htmlFor="email">
                      Email<span className="gfield_required asterisk">*</span>
                    </label>
                    <div className="ginput_container ginput_container_email">
                      <input
                        name="email"
                        id="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="large"
                        aria-required="true"
                        required
                        data-error-text="Please enter an email address."
                        data-error-text-secondary="Email addresses should have an @ symbol, no spaces or special characters, and include a domain name like gmail or yahoo."
                        aria-invalid="false"
                      />
                    </div>
                  </li>
                  <li className="gfield medium gfield_contains_required field_sublabel_below field_description_below">
                    <label className="gfield_label" htmlFor="phone">
                      Phone Number
                      <span className="gfield_required asterisk">*</span>
                    </label>
                    <div className="ginput_container ginput_container_phone">
                      <InputMask
                        name="phone"
                        id="phone"
                        type="tel"
                        value={formData.phone}
                        onChange={handleChange}
                        className="medium format-phone"
                        aria-required="true"
                        required
                        pattern="(\d{3}) \d{3}-\d{4}"
                        spellCheck="false"
                        maxLength="20"
                        data-error-text="Please enter a valid phone number."
                        data-error-text-secondary="Phone numbers must have 10 digits and only contain numbers."
                        aria-invalid="false"
                        placeholder=""
                        mask="(999) 999-9999"
                        maskChar="_"
                      />
                    </div>
                  </li>
                  <li className="gfield small gfield_contains_required ginput_container_zip field_sublabel_below field_description_below">
                    <label className="gfield_label" htmlFor="zip">
                      Zip Code
                      <span className="gfield_required asterisk">*</span>
                    </label>
                    <div className="ginput_container ginput_container_text">
                      <input
                        name="zip"
                        id="zip"
                        type="text"
                        value={formData.zip}
                        onChange={handleChange}
                        className="small format-zip"
                        maxLength="5"
                        aria-required="true"
                        required
                        placeholder="_____"
                        pattern="^([0-9]{5})$"
                        spellCheck="false"
                        data-error-text="Please enter a valid zip code."
                        data-error-text-secondary="Ensure your zip code isn&rsquo;t missing any numbers and doesn&rsquo;t contain any letters or special characters."
                        aria-invalid="false"
                      />
                    </div>
                  </li>

                  <li className="gfield-section-break">
                    <h3 className="h3">2. Professional Details</h3>
                  </li>
                  <li className="gfield gfield_contains_required field_sublabel_below field_description_below">
                    <label className="gfield_label" htmlFor="specialty">
                      Position
                      <span className="gfield_required asterisk">*</span>
                    </label>
                    <div className="ginput_container ginput_container_select">
                      <select
                        name="specialty"
                        id="specialty"
                        className="specialty_select"
                        value={formData.specialty}
                        onChange={handleChange}
                        aria-required="true"
                        data-error-text="Please select a valid position."
                        required
                      >
                        <option value="" disabled>
                          --Please Select--
                        </option>
                        {specialtyOptions.map((specialty) => (
                          <option key={specialty} value={specialty}>
                            {specialty}
                          </option>
                        ))}
                      </select>
                    </div>
                  </li>
                  <li className="gfield resume_gfield field_sublabel_below field_description_below">
                    <p className="gfield_label gfield_optional">
                      Upload Resume<span className="gfield_required asterisk">*</span>
                    </p>
                    <div
                      id="bhresume_selector"
                      className="ginput_complex ginput_container gfield_trigger_change"
                    >
                      {/*<span className="resumeuploads_first">
                                            <input type="file" className="resume-upload" name="uploaded_resume" id="uploaded_resume" accept=".doc, .docx, .txt, .rtf, .pdf, application/msword, text/rtf, application/vnd.wordperfect, application/wordperfect5.1, application/pdf" aria-label="Upload Resume" aria-invalid="false" />

                                            <div className={`bh-file-upload app ${isResumeActive ? 'resume-active' : ''}`} onClick={handleFileChangeClick} ref={containerRef}>Attach resume from...</div>
                                            <div className="bh-file-upload-choices" id="file_upload_choices">
                                                <label htmlFor="uploaded_resume">My Computer</label>
                                            </div>
                                        </span>*/}
                      <div className="resumeuploads_first">
                        <div className="trad-button-file-wrap">
                          <button
                            type="button"
                            id="resume-select-trad-file"
                            className="btn attach-resume-button"
                          >
                            Attach File{" "}
                          </button>
                          <div id="bhapply_file_preview">No File Uploaded</div>
                        </div>
                        <div className="bh-file-upload-size-error resume-error-msg">
                          File size too large.{" "}
                          <button type="button" className='bh-retry-file-upload'>Try again.</button>
                        </div>

                        <div className="bh-file-resume-is-required resume-error-msg">
                          Resume is required.
                        </div>

                        <input
                          type="file"
                          className="resume-upload"
                          name="uploaded_resume"
                          id="uploaded_resume"
                          /*value=''*/
                          onChange={handleFileChange}
                          aria-label="Upload Resume"
                          aria-invalid="true"
                          aria-required="true"
                          data-error-text="Please select a valid resume."
                          tabIndex="-1"
                        />
                      </div>

                      <span className="resumeuploads_last">
                        <input
                          type="hidden"
                          name="hid_attached_resume"
                          id="hid_attached_resume"
                          value="trad_true"
                        />
                      </span>
                      <div className="bh-file-upload-types">
                        <p className="file-types">
                          We accept .doc, .docx, .txt, .rtf or .pdf and must be
                          no larger than 3MB.
                        </p>
                      </div>
                      <div id="bhapply_file_preview"></div>
                    </div>
                  </li>
                  <li className="gfield field_sublabel_below gfield--type-checkbox subscribe-agreement">
                    <div className="ginput_container ginput_container_checkbox">
                      <ul className="gfield_checkbox">
                        <li className="gchoice">
                          <input
                            className="gfield-choice-input"
                            name="get_updates"
                            id="get_updates"
                            type="checkbox"
                            checked={formData.get_updates}
                            onChange={handleChange}
                            value="Yes, I would like to receive updates from RPh on the Go via SMS or email."
                          />
                          <label htmlFor="get_updates">
                            Yes, I would like to receive updates from RPh on the
                            Go via SMS or email.
                          </label>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="gfield gfield_contains_required field_sublabel_below gfield--type-checkbox privacy-agreement">
                    <div className="ginput_container ginput_container_checkbox">
                      <ul className="gfield_checkbox">
                        <li className="gchoice">
                          <input
                            className="gfield-choice-input"
                            id="agreement"
                            name="agreement"
                            type="checkbox"
                            checked={formData.agreement}
                            onChange={handleChange}
                            data-error-text="Please agree to the privacy statement."
                          />
                          <label htmlFor="agreement">
                            <span className="gfield_required">*</span> I have
                            read and agree with RPh on the Go{" "}
                            <a
                              href="/candidate-privacy/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Candidate Privacy Information Statement
                            </a>{" "}
                            that explains how RPh on the Go may use my
                            information with regard to me being a candidate for
                            work opportunities.
                            <br />{" "}
                            <a
                              href="#"
                              className="read-more-policy"
                              onClick={handleToggleClick}
                            >
                              {showMore ? "Read Less" : "Read More"}
                            </a>{" "}
                            {/* Instead of conditional rendering, we now conditionally add/remove a class */}
                            <div
                              className={`more-policy ${
                                showMore ? "is-visible" : ""
                              }`}
                            >
                              I understand and acknowledge that this Statement,
                              among other important disclosures, sets forth that
                              RPh on the Go may share my data with its
                              sister companies that are part of a nationwide
                              organization focused on providing human resource
                              services and solutions.
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="bhform_footer gform_footer top_label">
                <div class="form-btn form-btn--white">
                  <button type="submit" className="form-btn__inner">
                    Submit
                  </button>
                </div>
                {/*<img className="form_spinner" alt="[spinner]" src="/wp-content/themes/vocovision/modules/bh-apply/images/spinner.gif" />*/}
              </div>
            </form>
          </div>
          <div className="hidden" id="response" style={{ display: "block" }}>
            <pre>&nbsp;</pre>
          </div>
          <div className="bhapply_thankyou">
            Thanks for contacting us! We will get in touch with you shortly.
          </div>
        </div>
      </section>
    );
};

export default JobApplyForm;